export const PUBSUB_FF = 'confluence.frontend.notifications.pf-frontendpubsub-service_ylufe';
